import { useParams } from 'react-router-dom'
import { useGlobalContext } from '../../utils/Context'
import Sidebar from './components/Sidebar'
import Topbar from './components/Topbar'
import './Dashboard.scss'
import Home from './dashPages/home/Home'
import Bookings from './dashPages/bookings/Bookings'
import Booking from './dashPages/bookings/Booking'
import Transactions from './dashPages/transactions/Transactions'
import DropOff from './dashPages/dropOff/DropOff'
import Settings from './dashPages/settings/Settings'
import Webhooks from './dashPages/webhooks/Webhooks'
function UserDashboard() {
  const { page } = useParams()
  const { closeSideBar } = useGlobalContext()
  const activePage = () => {
    let active = ''
    switch (page) {
      case 'home':
        return <Home />
        break
      case 'bookings':
        return <Bookings />
      case 'booking':
        return <Booking />
      case 'transactions':
        return <Transactions />
      case 'drop-off':
        return <DropOff />
      case 'webhooks':
        return <Webhooks />
      case 'settings':
        return <Settings />

      default:
        break
    }
    return active
  }
  return (
    <div className='dashboard flex' onClick={closeSideBar}>
      <Sidebar page={page} />
      <div className='main'>
        <Topbar page={page} />
        <div className='main-body'>{activePage()}</div>
      </div>
    </div>
  )
}

export default UserDashboard
